import { render } from "./JoinNowStep02Location.vue?vue&type=template&id=b9c39e3c&scoped=true"
import script from "./JoinNowStep02Location.vue?vue&type=script&lang=js"
export * from "./JoinNowStep02Location.vue?vue&type=script&lang=js"

import "./JoinNowStep02Location.vue?vue&type=style&index=0&id=b9c39e3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c39e3c"]])

export default __exports__